import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo5/comic.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo5 } from "../../../routes/Module5";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo5/Actividad 7.mp3";

const Actividad7 = () => {
  const infoUnidad = modulo5.content[0];
  const infoAct = modulo5.content[0].activities[6];
  const crumbs = [
    {
      title: modulo5.title,
      url: "/" + modulo5.url,
    },
    {
      title:
        modulo5.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo5.content[0].activities[7].name}`,
    linkNext: `${modulo5.url}/${modulo5.content[0].path}/${modulo5.content[0].activities[7].path}`,
    titlePrev: `${modulo5.content[0].activities[5].name}`,
    linkPrev: `${modulo5.url}/${modulo5.content[0].path}/${modulo5.content[0].activities[5].path}`,
  };
  const metadata = {
    color: modulo5.color,
    title: `${modulo5.title} - ${infoAct.name}`,
    name: modulo5.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo5.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>Lee lo que nos cuentan Jailer y su mamá.</li>
      </ul>
      <img src={Imagen1} alt="Comic" className="img-fluid mt-2" />
      <div className="row mt-5 align-items-center">
        <div className="col-lg-8 col-12">
          <ul>
            <li>
              Conversa con un compañero, compañera o familiar sobre estas
              preguntas y luego escribe las respuestas.
            </li>
          </ul>
          <div className="ms-3">
            <p>¿Por qué está preocupado Jailer?</p>
            <textarea className="form-control mb-4" />
            <p>¿Por qué su mamá no le sacó su DNI cuando nació?</p>
            <textarea className="form-control mb-4" />
            <p>¿Qué van a hacer ahora Jailer y su mamá?</p>
            <textarea className="form-control" />
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Luego lean la historieta. Conversen sobre los
          temas de las preguntas y luego ayude a escribir las respuestas.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
